// --- COUNTRY OF ORIGIN ---
// Formularz docelowy nie ma pola telefonu (intl-tel-input), więc kraj pochodzenia
// wykrywamy po IP (api.country.is), z fallbackiem na region z locale przeglądarki.

const countryState = { detected: '' };

export function getDetectedCountry(): string {
  return countryState.detected;
}

function countryNameFromISO(iso: string): string {
  try {
    return new Intl.DisplayNames(['en'], { type: 'region' }).of(iso) || '';
  } catch {
    return '';
  }
}

export async function detectCountryOfOrigin(): Promise<void> {
  try {
    const res = await fetch('https://api.country.is/', { signal: AbortSignal.timeout(3000) });
    const data = (await res.json()) as { ip?: string; country?: string };
    if (data.country) {
      countryState.detected = countryNameFromISO(data.country);
      return;
    }
  } catch {
    // cichy fallback na locale
  }
  const localeRegion = (navigator.language || '').split('-')[1];
  if (localeRegion) countryState.detected = countryNameFromISO(localeRegion.toUpperCase());
}
